import { z } from 'zod';

export const validateSearch = z.object({
  articleId: z.uuid().optional(),
});
